<template>
  <TableLayout :permissions="['business:filerecord:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      
      <!-- <el-form-item label="文件名" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入文件名" @keypress.enter.native="search"></el-input>
      </el-form-item> -->
      
      <el-form-item label="文件夹名称" prop="folder">
        <el-input v-model="searchForm.folder" placeholder="请输入文件夹名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
     
      <el-form-item label="OSS文件key" prop="keyval">
        <el-input v-model="searchForm.keyval" placeholder="请输入OSS文件key" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="searchForm.status" clearable placeholder="请选择状态">
          <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item> 
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        border
        stripe
      >
       <el-table-column type="index" :index="newIndex" label="序号" width="80px" align="center"></el-table-column>
       <el-table-column prop="name" label="文件" width="100px" align="center">
        <template slot-scope="{row}">
          <el-image v-if="row.url" style="width: 70px; height: 70px" :src="row.url"
                  :preview-src-list="[row.url]" fit="cover"></el-image>
        </template>
       </el-table-column>
        <el-table-column prop="folder" label="文件夹名称" width="140px" align="center"></el-table-column>
        <el-table-column prop="keyval" label="OSS文件key" min-width="120px" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100px" align="center">
          <template slot-scope="{row}">
            <!--  0未上传 1已上传 2上传失败 -->
            {{ row.status == 0 ? '未上传' : row.status == 1 ? '已上传' : '上传失败' }}
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="150px" align="center"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" width="150px" align="center"></el-table-column>
<!--      
        <el-table-column prop="editor" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否删除0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="objId" label="关联对象编码" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型0图片 1视频 2其他" min-width="100px"></el-table-column> -->
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'FileRecord',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        name: '',
        info: '',
        objId: '',
        type: '',
        folder: '',
        status: '',
        keyval: ''
      },
      statusList: [
        // 0未上传 1已上传 2上传失败
        { name: '未上传', id: 0 },
        { name: '已上传', id: 1 },
        { name: '上传失败', id: 2 }
      ]
    }
  },
  created () {
    this.config({
      module: '附件上传进度表',
      api: '/business/fileRecord',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    newIndex(index) {
      return (this.tableData.pagination.pageIndex - 1) * 10 + index + 1
    }
  },
}
</script>
